import { render, staticRenderFns } from "./CreateFaqTypePage.vue?vue&type=template&id=5ad32831&scoped=true"
import script from "./CreateFaqTypePage.vue?vue&type=script&lang=js"
export * from "./CreateFaqTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad32831",
  null
  
)

export default component.exports